var _path, _path2, _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShapeSectionDivider1(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1920 365",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M539.5 1H0V365H1921V1H1384C1377 1 1361 1.5 1347 15C1332.6 30.2 1321 33.3333 1317 33H606C595 33 586.5 29.5 577.5 20C565.1 4.8 547 1 539.5 1Z",
    fill: "url(#paint0_linear_1326_383)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 1H539.5C547 1 565.1 4.8 577.5 20C586.5 29.5 595 33 606 33C614.8 33 1083.67 33 1317 33C1321 33.3333 1332.6 30.2 1347 15C1361 1.5 1377 1 1384 1C1389.6 1 1744.33 1 1921 1",
    stroke: "#322966",
    strokeOpacity: 0.8,
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1326_383",
    x1: 960.5,
    y1: 102.5,
    x2: 960.5,
    y2: 1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#070710"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.806277,
    stopColor: "#120C23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22153D"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapeSectionDivider1);
export default __webpack_public_path__ + "static/media/shape_section_divider_1.f276d27e20781da90097b94ff96d87c9.svg";
export { ForwardRef as ReactComponent };